'use client';

import CheckCircle from '/public/icons/check-circle.svg';
import CrossCircle from '/public/icons/cross-circle.svg';
import LoaderSmall from '/public/icons/loader-small-black.svg';
import type { StatusMessageProps } from './types';

export function StatusMessage({ variant, title, description, action }: StatusMessageProps) {
  return (
    <div className="flex flex-col items-center text-center px-4 py-6 md:px-8 md:py-[46px] w-full max-w-[454px]">
      <div className="flex items-center justify-center mb-[24px]">
        {variant === 'sending' && (
          <div className="inset-0 flex items-center justify-center ">
            <LoaderSmall className="animate-spin" />
          </div>
        )}
        {variant === 'success' && <CheckCircle />}
        {variant === 'error' && <CrossCircle />}
      </div>

      <h2 className="text-blue-900 light mb-[6px]">{title}</h2>

      {description && (
        <p className="md:text-body-regular text-body-small text-center text-grey-700">{description}</p>
      )}

      {action && <div className="mt-8 w-full">{action}</div>}
    </div>
  );
}
